/**
 * @desc 保存和编辑
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(params: API.mns.messageEvent.save.Params, options?: any) {
  return updateResponse(
    http(URL + `/messageEvent/save`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
